<template>
  <div style="width: 100%;" v-show="showAlarmDevices===2 && !showCritical">
    <div style="width: 100%;" v-if="filteredAlarmDevices">
      <vue-good-table
        class="table"
        :columns="alarmFields"
        :rows="filteredAlarmDevices"
        :line-numbers="true"
        :search-options="{
            enabled: true,
            externalQuery: searchTerm
          }"
        :sort-options="{
          enabled: true,
          // initialSortBy: {field: 'lastseen', type: 'desc'}
        }"
        :pagination-options="{ enabled: true }"
        @on-page-change="onPageChange"
        @on-per-page-change="onPageChange"
        @on-row-click="tableRowClicked"
      >
        <template slot="table-row" slot-scope="props" style="background: red;">
          <span v-if="props.column.field == 'status'">
            <div
              :key="`${props.row.TimeStamp}_${ props.row.InverterId}`"
              class="table_status"
              :class="{
                  'badge-danger': statusCalc(props.row.TimeStamp),
                  'badge-success': !statusCalc(props.row.TimeStamp)
                }"
            ></div>
          </span>
          <span v-else-if="props.column.field == 'ownerName'">
            <p>{{ props.row.ownerName }}</p>
          </span>
          <span v-else-if="props.column.field == 'InverterId'">
            <p>{{ props.row.InverterId }}</p>
          </span>
          <span v-else-if="props.column.field == 'deviceType'">{{ props.row.deviceType }}</span>
          <span v-else-if="props.column.field == 'version'">{{
            `${props.row.version} / ${props.row.FV}`
          }}</span>
          <span v-else-if="props.column.field == 'flags'">
            <el-badge
              v-for="(x,index) in Object.keys(props.row.flags)"
              :key="`alarm_badge_${index}`"
              :value="props.row.flags[x]"
              class="item"
              :type="badgeTypes[x].type"
            >
              <el-button  :type="badgeTypes[x].type" size="mini" plain>{{badgeTypes[x].label}}</el-button>
            </el-badge>
            <!-- {{ props.row.flags }} -->
          </span>
          <span v-else-if="props.column.field == 'panelpower'">{{ props.row.panelpower }}</span>
          <!-- <span v-else-if="props.column.field == 'InverterId'">{{ props.row.InverterId }}</span> -->
          <span v-else-if="props.column.field == 'OutputLoadPercent'">{{
              `${props.row.contractualLoad} / ${props.row.OutputLoadPercent}`
          }}%
          </span>
          <span v-else-if="props.column.field == 'installedCapacity'">{{
            `${props.row.installedPV} / ${props.row.installedCapacity}`
          }}</span>
          <span
            v-else-if="props.column.field == 'devicestatus'"
            style="display: flex; flex-flow: row;"
          >{{ props.row.batteryMode }}</span>

          <span
            v-else-if="props.column.field == 'BatteryCapacity'"
            style="display: flex; flex-flow: row;"
          >
            <battery
              :mini="true"
              :width="`18px`"
              :height="`10px`"
              :direction="`y`"
              style="margin-top: 5px;"
              :level="props.row.BatteryCapacity"
            ></battery>

            <span>{{ `${props.row.BatteryCapacity * 1}%` }}</span>
          </span>

          <span v-else-if="props.column.field == 'Time'">{{
            `${formatDate(props.row.Time)}`
          }}</span>

          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :currentPage="tableOptions.currentPage"
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
            @paginated-info="showPaginatedInfo($event)"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
    <!-- <div
      style="display: flex; flex-flow: column; min-height: 500px; justify-content: center; align-items: center;"
      v-else-if="!filteredAlarmDevices && !showCritical"
    >
      <span
        class="fa fa-spinner fa-4x animated rotateIn infinite loadingState"
        style="color: #1a93ca;"
      ></span>
      <h3>Wait a second..</h3>
    </div>-->
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

import Status from "../../kitchen/status-indicator";
import moment from "moment";
import Battery from "../../kitchen/grey-battery";
import {
  Badge,
  Button
  // ...
} from "element-ui";
Vue.use(Badge);
Vue.use(Button);
let items = [];
export default {
  name: "offlineDevices",
  props: {
    showAlarmDevices: {
      type: Number,
      default: null
    },
    formatDate: { type: Function },
    showCritical: { type: Boolean },
    tableRowClicked: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    activeTab: { type: Boolean },
    filteredAlarmDevices: { type: Array }
  },
  components: {
    Battery,
    Status
  },
  computed: {
    ...mapGetters(["offLineDeviceList", "getGlobalTableOptions"]),
    alarmFields: {
      get() {
        return [
          ...this.fields_,
          {
            key: "flags",
            label: "Alarms",
            sortable: "true",
            field: "flags",
            filterable: true
          }
        ];
      }
    },
    tableOptions: {
      get() {
        return this.getGlobalTableOptions.performance;
      }
    }
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      badgeTypes:{
        "warning":{
          type:"warning",
          label: "Minor"
        },
        "error": {
          type:"danger",
          label: "Major"
        }
      }
    };
  },
  methods: {
    ...mapActions(["setGlobalTableOptions"]),
    showPaginatedInfo(paginatedInfoString) { this.$emit("paginated-info", paginatedInfoString) },
    statusCalc(date) {
      var difference = Math.abs(moment(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onPageChange(params) {
      let tmpState = {
        ...this.getGlobalTableOptions,
        performance: { ...params }
      };
      if (this.activeTab === true) {
        // console.log("Offline"+this.activeTab );
        this.setGlobalTableOptions(tmpState);
      }
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    }
  },
  mounted() {
    // vm.$forceUpdate();
    // window.location.reload();
    // console.log({ offLineDeviceList: this.offLineDeviceList });
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/performance/widgets/alarmDevices.vue